// const apiUrl = 'http://gamsumo.yorc.ru';
const apiUrl = '///myktyaimak.gov.kg';
const trackingId = 'G-HBXET4B8TE';

export default {
  apiUrl: apiUrl,
  trackingId: trackingId
};

